var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-toolbar-title',_vm._g(_vm._b({staticClass:"text-sm-h5 text-subtitle-1",staticStyle:{"cursor":"pointer"},on:{"click":_vm.redirectToIndex}},'v-toolbar-title',attrs,false),on),[_vm._v(_vm._s(_vm.title))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.titleSpan))])])}
var staticRenderFns = []

export { render, staticRenderFns }